import { TranslocoService } from '@jsverse/transloco'
import { Editor, RawEditorOptions } from 'hugerte'

const TAG_CONTENT_STYLE = `
  body { font-family: Arial, sans-serif; font-size: 14px; line-height: 1.6; padding: 16px; margin: 0; color: #222428; }
  p { margin: 0 0 12px 0; } p:last-child { margin-bottom: 0; }
  a { color: #3880ff; text-decoration: underline; }
  .tag-anchor {
    display: inline-block;
    padding: 2px 6px;
    border-radius: 3px;
    font-size: 0.875em;
    font-weight: 500;
    cursor: pointer;
    user-select: none;
    white-space: nowrap;
    text-decoration: none;
    background-color: rgba(var(--tag-color), 0.18);
  }
  .tag-anchor.hovered {
    background-color: rgba(var(--tag-color), 0.28);
    box-shadow: 0 0 0 2px rgba(var(--tag-color), 0.55), 0 0 10px 2px rgba(var(--tag-color), 0.25);
  }
  .tag-anchor.tag-highlight {
    box-shadow: 0 0 0 2px rgba(var(--tag-color), 0.7), 0 0 10px 4px rgba(var(--tag-color), 0.35);
  }
  .tag-anchor.tag-highlight-fade {
    box-shadow: none;
    transition: box-shadow 0.4s ease-out;
  }
`

export interface TagEditorConfigOpts {
  placeholder: string
  transloco: TranslocoService
  setup?: (editor: Editor) => void
  pastePreprocess?: (plugin: unknown, args: { content: string }) => void
}

export function createTagEditorConfig(opts: TagEditorConfigOpts): RawEditorOptions {
  return {
    base_url: '/hugerte',
    suffix: '.min',
    menubar: false,
    branding: false,
    promotion: false,
    statusbar: false,
    plugins: 'lists link',
    paste_webkit_styles: 'all',
    paste_merge_formats: false,
    toolbar: 'inserttag | undo redo | bold italic underline | numlist bullist | link',
    noneditable_class: 'mceNonEditable',
    extended_valid_elements: '+*[*]',
    verify_html: false,
    content_style: TAG_CONTENT_STYLE,
    placeholder: opts.placeholder,
    height: 400,
    min_height: 300,
    mobile: { toolbar_location: 'bottom', toolbar_mode: 'wrap' },
    ...(opts.pastePreprocess && { paste_preprocess: opts.pastePreprocess }),
    ...(opts.setup && { setup: opts.setup }),
  }
}
